export default __webpack_public_path__ + "static/media/leader 1.1403e5cc.png";